import styled from 'styled-components';

export const OrderModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
`;
